/**
 * Copy to clipboard, safely.
 *
 * `navigator.clipboard` does not exist on an insecure origin (plain http on a phone), and even where it
 * does the write can be refused. Calling it unguarded means the Copy button silently throws and does
 * nothing, with no feedback. This tries the async API, falls back to a hidden textarea + execCommand for
 * older or insecure contexts, and reports whether it worked so the caller can show "copied" or a manual
 * fallback rather than pretending.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through to the legacy path */
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
